import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import crypto from 'crypto';
import { useMemo } from 'react';
import { NLPSearchResultFormat } from '../../../ai-answer-dialog';
import { NLPSearchJSONResultFormat } from '../../../ai-answer-dialog/types';
import { getTypedJSONResultDataAssistanceService } from '../../../ai-answer-dialog/utils/getTypedJSONResultData';
import { sha256Hash } from '../../../utils';
export var getCardType = function getCardType(_ref) {
  var isReadingAids = _ref.isReadingAids,
    answerFormat = _ref.answerFormat,
    parsedType = _ref.parsedType;
  if (isReadingAids) {
    return 'definition';
  }
  if (answerFormat === NLPSearchResultFormat.JSON && parsedType === NLPSearchJSONResultFormat.WHO) {
    return 'people';
  }
  if (answerFormat === NLPSearchResultFormat.JSON && parsedType === NLPSearchJSONResultFormat.WORK) {
    return 'work';
  }
  return 'SAIN';
};
export var getParsedType = function getParsedType(_ref2) {
  var answerFormat = _ref2.answerFormat,
    answerString = _ref2.answerString;
  if (answerFormat !== NLPSearchResultFormat.JSON) {
    return undefined;
  }
  return getTypedJSONResultDataAssistanceService(answerString).parsedType;
};
var sanitizeSources = function sanitizeSources(sources) {
  return sources.map(function (source) {
    var _source$ari;
    return {
      id: (_source$ari = source.ari) !== null && _source$ari !== void 0 ? _source$ari : source.id,
      type: source.type
    };
  });
};
var has3PSources = function has3PSources(sources) {
  return sources.filter(function (source) {
    var _source$ari2;
    return (_source$ari2 = source.ari) === null || _source$ari2 === void 0 ? void 0 : _source$ari2.includes('third-party');
  });
};

// New instrumentation attributes must be added to this function to be included in all the events
export var filterCommonAttributes = function filterCommonAttributes(props) {
  var appliedFilters = props.appliedFilters,
    answerFormat = props.answerFormat,
    answerLength = props.answerLength,
    answerCardType = props.answerCardType,
    followUps = props.followUps,
    sources = props.sources,
    extraAttributes = props.extraAttributes,
    searchSessionId = props.searchSessionId,
    queryHash = props.queryHash,
    baseQueryHash = props.baseQueryHash,
    query = props.query,
    answerString = props.answerString,
    apiSource = props.apiSource,
    brand = props.brand,
    sessionId = props.sessionId;
  return _objectSpread({
    searchSessionId: searchSessionId,
    queryHash: queryHash,
    baseQueryHash: baseQueryHash,
    wordCount: (query.match(/\w+/g) || []).length,
    queryLength: query.length,
    answerHash: sha256Hash(answerString),
    appliedFilters: appliedFilters,
    answerFormat: answerFormat,
    answerLength: answerLength,
    answerCardType: answerCardType,
    followUpsCount: followUps.length,
    followUpsLength: followUps.map(function (followUp) {
      return followUp.length;
    }),
    sources: sanitizeSources(sources),
    has3PSources: has3PSources(sources).length ? true : false,
    apiSource: apiSource,
    brand: brand,
    sessionId: sessionId
  }, extraAttributes);
};
export var useSessionId = function useSessionId(_ref3) {
  var userId = _ref3.userId,
    cloudId = _ref3.cloudId,
    source = _ref3.source;
  return useMemo(function () {
    return crypto.createHash('sha256').update("".concat(userId, "-").concat(cloudId, "-").concat(Date.now().toString(), "-").concat(source)).digest('hex');
  }, [userId, cloudId, source]);
};